import React from 'react';
import { Form } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { AddressStateStore } from "../Store/entities/addressStates";
import { useStateList, useStatesLoadStatus } from "../Store/entities/hooks";
import { StateSelectorTypedProps } from "./types";

const StateSelectorTyped = ({
	currentStateCode,
	onChange,
	disabled = false,
	touched = false,
	error = '',
	isMailingAddress = false,
	className = ""
}: StateSelectorTypedProps & {
	touched?: boolean;
	error?: string;
	isMailingAddress?: boolean;
}) => {
	const states = useStateList();
	const loading = useStatesLoadStatus() <= 3;
	
	const selectedStateObj = states.find((state) =>
		(state.code.toLowerCase() === (currentStateCode || "").toLowerCase())
			|| (state.name.toLowerCase() === (currentStateCode || "").toLowerCase()));
	const selectedState = selectedStateObj ? [selectedStateObj] : [];

	const isInvalid = touched && (!!error || error.length > 0 || currentStateCode.length < 1);
	const isValid = touched && currentStateCode.length && (!error || error.length < 1);

	return (
		<Form.Group>
			<Form.Label className={className}>
				State
				<Typeahead
					id="state-select"
					clearButton
					paginate
					flip
					placeholder={loading ? "Loading States..." : "Select State..."}
					options={states}
					disabled={disabled}
					isLoading={loading}
					labelKey="name"
					selected={selectedState || []}
					onChange={(selection) => {
						const selected = selection[0] as AddressStateStore | undefined;
						onChange(selected?.code ?? '');
					}}
					inputProps={{
						autoComplete: "new-password",
						className: isInvalid ? 'is-invalid' : isValid ? 'is-valid' : ''
					}}
					className={`form-control p-0 ${isInvalid ? 'is-invalid' : isValid ? 'is-valid' : ''}`}
				/>
			</Form.Label>
			{isInvalid ? (
				<Form.Control.Feedback type="invalid" className="d-block">
					{error || `${isMailingAddress ? "Mailing" : "Billing"} State is required`}
				</Form.Control.Feedback>
			) : null}
			{isValid ? (
				<Form.Control.Feedback type="valid" className="d-block">
					Looks good!
				</Form.Control.Feedback>
			) : null}
		</Form.Group>
	);
};

export default StateSelectorTyped;
